export default "__VITE_ASSET__BtGwfp7f__"